var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4919 20.1582L18.4919 23.6582C18.492 24.4299 18.5441 25.1114 17.9995 25.6582C17.4549 26.205 16.7712 26.1551 15.9995 26.1582L3.99951 23.6582C3.61629 23.6597 3.22425 23.5504 2.86962 23.4052C2.515 23.2599 2.19248 23.0462 1.92048 22.7762C1.64848 22.5062 1.43234 22.1853 1.28441 21.8318C1.13647 21.4783 1.05964 21.0991 1.0583 20.7158L0.999954 6.08715C0.998419 5.70404 1.07236 5.32439 1.21755 4.96986C1.36274 4.61533 1.57634 4.29287 1.84615 4.0209C2.11596 3.74892 2.4367 3.53275 2.79005 3.38473C3.14341 3.2367 3.52246 3.15973 3.90556 3.1582L13.4996 1.6582C14.2733 1.6582 17.9526 0.611107 18.4997 1.1582C19.0468 1.7053 18.9995 2.88449 18.9995 3.6582L18.9995 6.08715",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9995 18.1582L29.9995 13.1582L24.9995 8.1582M29.9995 13.1582L14.9995 13.1582",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.25ae67e33411d4663a4a5d618a3f1ff2.svg";
export { ForwardRef as ReactComponent };